module.exports = __webpack_public_path__ + "static/media/Pong.f6bd5b9c.jpg";